import { Component } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import 'firebase/firestore';
import { Router, ActivatedRoute } from '@angular/router';
import { $WebSocket } from 'angular2-websocket/angular2-websocket'
import { Moment } from 'moment';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-root',
  template:`
    Zbog tehničkih problema, dok ne bude urađena verifikacija koju čekamo,
    možete pratiti instrukcije iz video uputstva sa linka kako biste omogućili
    gledanje klipova. 
    <br> 
    <b>Uputstvo:</b>
    <a target="_blank" href='https://drive.google.com/file/d/1z-E6g0SROZD8jJCVstKUVse5SwVu6ajC/view?usp=sharing'>
    https://drive.google.com/file/d/1z-E6g0SROZD8jJCVstKUVse5SwVu6ajC/view?usp=sharing </a>
    Izvinjavamo se svima na smetnjama. 
    <br> 
    Binary Bioskop tim
  `,
  styleUrls: ['./app.component.scss']
})
export class NotificationDialogComponent {
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private auth: AngularFireAuth,
    private router: Router,
    private route: ActivatedRoute,
    private firestore: AngularFirestore,
    private dialog:MatDialog
  ) {
    auth.onAuthStateChanged(async (userInfo) => {
      if (this.getBrowserName() === 'chrome' && window.location.pathname != '/only-chrome') {
        if (userInfo) {
        } else {
          // if (router.url != '/uslovi-koriscenja' && route.snapshot.queryParamMap.get('tab') === null)
          // router.navigateByUrl('/')
        }
      }
    })
  }
  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
}
export function indeksValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const forbidden = nameRe.test(control.value);
    return !forbidden ? { 'forbiddenName': { value: control.value } } : null;
  };
}


export function isMyDateFormat(date: string): string {
  if (date.length !== 10) {
    return 'Invalid input: Please input a string in the form of YYYY-MM-DD';
  } else {
    const da = date.split('-');
    if (da.length !== 3 || da[0].length !== 4 || da[1].length !== 2 || da[2].length !== 2) {
      return 'Invalid input: Please input a string in the form of YYYY-MM-DD';
    } else if (moment(date).isValid()) {
      return 'Invalid date: Please input a date no later than today';
    } else if (!moment(date).isValid()) {
      return 'Invalid date: Please input a date with a valid month and date.';
    }
  }
  return 'Unknown error.';
}